import React from 'react'
import { blogPermissions } from '@ztechapps/blog.common'
import { Alert } from '@ztechapps/webui.util'

export const RelatedPostsDeniedAlert = () => (
  <Alert type="danger">You need the {blogPermissions.canView.value} permission to see related posts.</Alert>
)
